var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1855,4746c-67-29-105-106-91-181c9-47,59-102,104-115c25-8,257-10,714-8c665,3,677,3,704,24c53,39,69,71,69,134 s-16,95-69,134c-27,21-38,21-714,23C2016,4759,1879,4757,1855,4746z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735,4266c-94-41-124-168-58-247c40-47,79-59,187-59h96l2-1532l3-1533l28-82c67-197,223-353,421-421l81-27l1030-3 c906-2,1039-1,1108,13c232,47,417,211,495,439l27,81l3,1532l2,1531l109,4c92,2,114,6,137,24c53,39,69,71,69,134s-16,95-69,134 l-27,21l-1807,2C1085,4279,760,4277,735,4266z M3838,2448l-3-1513l-26-55c-37-80-81-125-157-162l-67-33H2560H1535l-67,33 c-76,37-120,82-157,162l-26,55l-3,1513l-2,1512h1280h1280L3838,2448z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935,3226c-41-18-83-69-90-109c-3-18-5-406-3-864c3-822,3-832,24-859c39-53,71-69,134-69s95,16,134,69c21,27,21,34,21,886 s0,859-21,886c-11,15-32,37-46,47C2055,3238,1975,3245,1935,3226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3055,3226c-41-18-83-69-90-109c-3-18-5-406-3-864c3-822,3-832,24-859c39-53,71-69,134-69s95,16,134,69c21,27,21,34,21,886 s0,859-21,886c-11,15-32,37-46,47C3175,3238,3095,3245,3055,3226z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.4a185022c9c660e42bc585d6d1b845cc.svg";
export { ForwardRef as ReactComponent };